import { SvgIcon } from "@mui/material";

const Trash = (props) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M14.4188 1.5C14.9049 1.5 15.3509 1.78088 15.5679 2.22557L15.8571 2.8125H19.7143C20.4254 2.8125 21 3.40025 21 4.125C21 4.84975 20.4254 5.4375 19.7143 5.4375H4.28571C3.57576 5.4375 3 4.84975 3 4.125C3 3.40025 3.57576 2.8125 4.28571 2.8125H8.14286L8.43214 2.22557C8.64911 1.78088 9.09509 1.5 9.58125 1.5H14.4188Z"
        fill="#738499"
      />
      <path
        d="M19.7176 19.875C19.7176 21.3229 18.5645 22.5 17.1462 22.5H6.86049C5.44018 22.5 4.28906 21.3229 4.28906 19.875V5.4375H19.7176V19.875ZM8.78906 8.71875C8.78906 8.35781 8.49978 8.0625 8.1462 8.0625C7.79263 8.0625 7.50335 8.35781 7.50335 8.71875V17.9062C7.50335 18.2672 7.79263 18.5625 8.1462 18.5625C8.49978 18.5625 8.78906 18.2672 8.78906 17.9062V8.71875ZM12.6462 8.71875C12.6462 8.35781 12.3569 8.0625 12.0033 8.0625C11.6498 8.0625 11.3605 8.35781 11.3605 8.71875V17.9062C11.3605 18.2672 11.6498 18.5625 12.0033 18.5625C12.3569 18.5625 12.6462 18.2672 12.6462 17.9062V8.71875ZM16.5033 8.71875C16.5033 8.35781 16.2141 8.0625 15.8605 8.0625C15.5069 8.0625 15.2176 8.35781 15.2176 8.71875V17.9062C15.2176 18.2672 15.5069 18.5625 15.8605 18.5625C16.2141 18.5625 16.5033 18.2672 16.5033 17.9062V8.71875Z"
        fill="#DCE5F0"
      />
    </SvgIcon>
  );
};

export default Trash;
